module.exports = __webpack_public_path__ + "static/media/map.e34eab0b.png";